import {
  getAllUsers,
  getUser,
  login,
  removeUser,
  updateUser,
  changePassword,
  createEmployee,
  forgotPassword,
  resetPassword,
  restoreUser
} from "../../api";

import { FAILURE, REQUEST, SUCCESS, USER_REQUEST } from "../utilities";

export function LOGIN(userData, moveToNext, failure) {
  return (dispatch) => {
    dispatch(REQUEST(USER_REQUEST.LOGIN_REQUEST));
    login(userData)
      .then((response) => {
        if (response.data.succeeded === true) {
          const userObject = response.data.user;

          const token = response.data.token;

          const userWithToken = {
            ...userObject,
            token: token,
          };
          localStorage.setItem("user", JSON.stringify(userWithToken));

          dispatch(SUCCESS(USER_REQUEST.LOGIN_SUCCESS, userWithToken));

          if (moveToNext) {
            moveToNext();
          }
        } else {
          dispatch(FAILURE(USER_REQUEST.LOGIN_FAILURE, response.data.message));
          if (failure) {
            failure();
          }
        }
      })
      .catch((error) => {
        dispatch(FAILURE(USER_REQUEST.LOGIN_FAILURE, error.message));
        if (failure) {
          failure(error.response?.data?.message ||
            error.message ||
            "Login Failed");
        }
      });
  };
}

export const LOGOUT = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: USER_REQUEST.LOGOUT_REQUEST });
      await new Promise((resolve) => setTimeout(resolve, 200));
      localStorage.removeItem("user");
      dispatch({ type: USER_REQUEST.LOGOUT_SUCCESS });
    } catch (error) {
      dispatch({ type: USER_REQUEST.LOGOUT_FAILURE, payload: error.message });
    }
  };
};

export function CREATEUSER(userData, token, successCallback, failure) {
  return (dispatch) => {
    dispatch(REQUEST(USER_REQUEST.CREATE_REQUEST));
    createEmployee(userData, token).then((response) => {
    
      if (response.data.succeeded === true) {
        dispatch({ type: USER_REQUEST.CREATE_SUCCESS, payload: response.data.data });

        if (successCallback) {
          successCallback(response.data.data);
        }
      } else {
        dispatch({ type: USER_REQUEST.CREATE_FAILURE, payload: response?.data?.message || "Failed" });
        if (failure) {
          failure(response?.data?.message || "Failed")
        }
      }
    }, error => {
      dispatch({ type: USER_REQUEST.CREATE_FAILURE, payload: error?.response?.data?.message || error?.message || "Failed" });
      if (failure) {
        failure(error?.response?.data?.message || error?.message || "Failed")
      }
    })
  };
}


export function GETALLUSERS(params, auth, success, failure) {
  return (dispatch) => {
    dispatch(REQUEST(USER_REQUEST.GET_ALL_USERS_REQUEST));
    getAllUsers(params, auth).then((response) => {
  
      if (response.data.succeeded === true) {
        dispatch({ type: USER_REQUEST.GET_ALL_USERS_SUCCESS, payload: response.data.data });

        if (success) {
          success(response.data.data);
        }
      } else {
        dispatch({ type: USER_REQUEST.GET_ALL_USERS_FAILURE, payload: response?.data?.message || "Failed" });
        if (failure) {
          failure(response?.data?.message || "Failed")
        }
      }
    }, error => {
      dispatch({ type: USER_REQUEST.GET_ALL_USERS_FAILURE, payload: error?.response?.data?.message || error?.message || "Failed" });
      if (failure) {
        failure(error?.response?.data?.message || error?.message || "Failed")
      }
    })
    // if (!auth || !auth.token) {
    //   const errorMessage = "Authentication token is missing.";
    //   dispatch(FAILURE(USER_REQUEST.GET_ALL_USERS_FAILURE, errorMessage));
    //   if (failure) failure(errorMessage);
    //   return;
    // }

    // getAllUsers(data, auth).then(
    //   (response) => {
    //     if (response.data.succeeded === true) {
    //       dispatch(
    //         SUCCESS(USER_REQUEST.GET_ALL_USERS_SUCCESS, response.data.data)
    //       );
    //     } else {
    //       dispatch(
    //         FAILURE(USER_REQUEST.GET_ALL_USERS_FAILURE, response.data.message)
    //       );
    //     }
    //   },
    //   (error) => {
    //     const errorMessage =
    //       error.response?.data?.message || "Failed to fetch users.";
    //     dispatch(FAILURE(USER_REQUEST.GET_ALL_USERS_FAILURE, errorMessage));
    //   }
    // );
  };
}

export function GETUSER(id, token, moveToNext, failure) {
  return (dispatch) => {
    dispatch(REQUEST(USER_REQUEST.GET_USER_REQUEST));
    getUser(id, token).then(
      (response) => {
        if (response.data.succeeded) {
          dispatch(SUCCESS(USER_REQUEST.GET_USER_SUCCESS, response.data.data));
          if (moveToNext) {
            moveToNext(response.data.data);
          }
        } else {
          dispatch(
            FAILURE(USER_REQUEST.GET_USER_FAILURE, response.data.message)
          );
          if (failure) {
            failure(response?.data?.message || "Failed")
          }
        }
      },
      (error) => {
        const errorMessage = error.response?.data?.message || error.message;
        dispatch(FAILURE(USER_REQUEST.GET_USER_FAILURE, errorMessage));
        if (failure) {
          failure(error?.response?.data?.message || error?.message || "Failed")
        }
      }
    );
  };
}





export function REMOVEUSER(filter, id, auth, moveToNext, failure) {
  return (dispatch) => {
    dispatch(REQUEST(USER_REQUEST.REMOVE_USER_REQUEST));
    removeUser(filter, id, auth).then(
      (response) => {
        if (response.data.succeeded) {
          dispatch(
            SUCCESS(USER_REQUEST.REMOVE_USER_SUCCESS, response.data.data)
          );
          if (moveToNext) {
            moveToNext('Employee deleted successfully!');
          }
        } else {
          dispatch(
            FAILURE(USER_REQUEST.REMOVE_USER_FAILURE, response.data.message)
          );
          if (failure) {
            failure(response.data.message);
          }
        }
      },
      (error) => {
        dispatch(FAILURE(USER_REQUEST.REMOVE_USER_FAILURE, error.message));
        if (failure) {
          failure(error?.response?.data?.message || error?.message || "Failed")
        }
      }
    );
  };
}


export function RESTOREUSER(id, auth, moveToNext, failure) {
  return (dispatch) => {
    dispatch(REQUEST(USER_REQUEST.REMOVE_USER_REQUEST));
    restoreUser(id, auth).then(
      (response) => {
        if (response.data.succeeded) {
          dispatch(
            SUCCESS(USER_REQUEST.REMOVE_USER_SUCCESS, response.data.data)
          );
          if (moveToNext) {
            moveToNext('Employee Restore successfully!');
          }
        } else {
          dispatch(
            FAILURE(USER_REQUEST.REMOVE_USER_FAILURE, response.data.message)
          );
          if (failure) {
            failure(response.data.message);
          }
        }
      },
      (error) => {
        dispatch(FAILURE(USER_REQUEST.REMOVE_USER_FAILURE, error.message));
        if (failure) {
          failure(error?.response?.data?.message || error?.message || "Failed")
        }
      }
    );
  };
}

export function UPDATEUSER(userData, token, moveToNext, failure) {
  return (dispatch) => {
    dispatch(REQUEST(USER_REQUEST.UPDATE_EMPLOYEE_REQUEST));
    updateUser(userData, token).then(
      (response) => {
        if (response.data.succeeded) {
          dispatch(
            SUCCESS(USER_REQUEST.UPDATE_EMPLOYEE_SUCCESS, response.data.data)
          );
          if (moveToNext) moveToNext(response.data.data);
        } else {
          dispatch(
            FAILURE(USER_REQUEST.UPDATE_EMPLOYEE_FAILURE, response.data.message)
          );
          if (failure) {
            failure(response?.data?.message || "Failed")
          }
        }
      },
      (error) => {
        dispatch(FAILURE(USER_REQUEST.UPDATE_USER_FAILURE, error.message));
        if (failure) {
          failure(error?.response?.data?.message || error?.message || "Failed")
        }
      }
    );
  };
}




export function updateCurrentUser(userData, auth, moveToNext, failure) {
  return (dispatch) => {
    dispatch(REQUEST(USER_REQUEST.UPDATE_USER_REQUEST));

    updateUser(userData, auth).then(
      (response) => {
        if (response.data.succeeded) {
          let data = JSON.parse(localStorage.getItem("user")) || {};
          
          let final_data = { ...response.data.data, token: data.token };

          dispatch(
            SUCCESS(USER_REQUEST.UPDATE_USER_SUCCESS, final_data)
          );

          localStorage.setItem("user", JSON.stringify(final_data));

          if (moveToNext) {
            moveToNext("Profile Update Successfully");
          }
        } else {
          dispatch(
            FAILURE(USER_REQUEST.UPDATE_USER_FAILURE, response.data.message)
          );
          if (failure) {
            failure(response.data.message);
          }
        }
      },
      (error) => {
        dispatch(FAILURE(USER_REQUEST.UPDATE_USER_FAILURE, error.message));
        if (failure) {
          failure(error.message);
        }
      }
    );
  };
}
export function forgetPassword(email, moveToNext, failure) {
  return (dispatch) => {
    dispatch(REQUEST(USER_REQUEST.FORGET_USER_PASSWORD));

    forgotPassword(email)
      .then((response) => {

        if (response.data.succeeded) {
          dispatch(SUCCESS(USER_REQUEST.FORGET_USER_PASSWORD, response.data.data));

          if (moveToNext) {
            moveToNext("OTP sent!");
          }
        } else {
          dispatch(FAILURE(USER_REQUEST.FORGET_USER_PASSWORD, response.data.message));
        }
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.message || "Something went wrong";
        dispatch(FAILURE(USER_REQUEST.FORGET_USER_PASSWORD, errorMessage));
        if (failure) {
          failure(errorMessage)
        }
      });
  };
}

export function Reset_Password(otp, password, moveToNext, failure) {
  return (dispatch) => {
    dispatch(REQUEST(USER_REQUEST.RESET_USER_PASSWORD));

    resetPassword(otp, password).then((response) => {
      if (response.data.succeeded) {
        dispatch(SUCCESS(USER_REQUEST.RESET_USER_PASSWORD, response.data.data));

        if (moveToNext) {
          moveToNext("Password Reset Successfully")
        }

        else {
          dispatch(FAILURE(USER_REQUEST.RESET_USER_PASSWORD, response.data.message));
        }
      }
    })
      .catch((error) => {
        const errorMessage = error?.response?.data?.message || "Something went wrong";
        dispatch(FAILURE(USER_REQUEST.RESET_USER_PASSWORD, errorMessage));

        if (failure) {
          failure(errorMessage)
        }
      });
  }
}

export function changeUserPassword(userData, auth, moveToNext, failure) {
  return (dispatch) => {
    dispatch(REQUEST(USER_REQUEST.UPDATE_PASSWORD_REQUEST));

    changePassword(userData, auth).then(
      (response) => {
        if (response.data.succeeded) {
          dispatch(
            SUCCESS(USER_REQUEST.UPDATE_PASSWORD_SUCCESS, response.data.data)
          );

          if (moveToNext) {
            moveToNext("Password Updated Successfully");
          }
        } else {
          dispatch(
            FAILURE(USER_REQUEST.UPDATE_PASSWORD_FAILURE, response.data.message)
          );
          if (failure) {
            failure(response.data.message);
          }
        }
      },
      (error) => {
        dispatch(FAILURE(USER_REQUEST.UPDATE_PASSWORD_FAILURE, error.message));
        if (failure) {
          failure(error?.response?.data?.message || "Failed to Update");
        }
      }
    );
  };
}



